import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { GlobalConsignmentService } from 'src/app/_services/global-consignment.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';

@Component({
    selector: 'app-global-request-summary',
    templateUrl: './global-request-summary.component.html',
    styleUrls: ['./global-request-summary.component.scss'],
    providers: [ConfirmationService],
    standalone: false
})
export class GlobalRequestSummaryComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data: any
  requestTypeOption: any
  type: any
  requisitionData: any[]= [];
  requisitions: any;
  message: any;
  optionLabel: any;
  buttonLabel: any;
  actionData: string;
  comment: any;
  totalQuantity: number = 0;
  constructor(    
    private util: UtilServiceService,
    public modalRef : BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private route: ActivatedRoute,
    private globalConsignmentService:GlobalConsignmentService,
    private confirmationService: ConfirmationService,
    private spinner:NgxSpinnerService,
    private errorUtil: ErrorUtil
  ) {
    super();
   }

  ngOnInit(): void {
    console.log(this.data,"===",this.type)
    this.requestTypeOption = this.data.requestTypeOption
    this.requisitionData = this.type == 'Consignment' ? this.data.consignmentValues : this.data.requisitionValues;
    this.requisitions = this.type == 'Consignment' ? this.data.consignment : this.data.requisition;
    this.calculateTotalQuantity();
console.log(this.requisitionData)

    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      })
    );
  }  
  push(obs: any) {
    super.push(obs);
  }
  goBack() {
    this.util.goBack();
  }



binTransfersUpdateStatus(assignedStatus: any,data: any){
  this.actionData = assignedStatus
  console.log(assignedStatus,"===",this.requisitions)
  var runningNumber = this.type == 'Consignment' ? this.requisitions.consignmentNumber : this.requisitions.requisitionNumber;
  if(assignedStatus == "REJECTED"){
   
    this.message = this.translate?.general.messages.areYouSureReject+" "+runningNumber +"?"
    this.optionLabel = this.translate?.general.messages.rejectionConfirmation
    this.actionData = 'REJECTED'
    this.confirm1()

   }else if(assignedStatus == "APPROVED"){
    this.message = this.translate?.general.messages.areYouSureApprove+" "+runningNumber + "?"
      this.optionLabel = this.translate?.general.messages.approvalConfirmation
      this.actionData = 'APPROVED'
      this.confirm1()
    }else{
      this.message =  this.translate?.binTransfer.messages.cancelTransfer
      this.optionLabel = this.translate?.general.buttons.cancel.singular
      this.data.value = 'CANCEL'
      this.confirm1()
  }
 
 
}
 showDialog() { 
       // this.display = true;
    }
confirm1() {
  this.confirmationService.confirm({
      key: 'binTransfer',
      message: this.message,
      accept: () => {
        this.onSubmit()
        //Actual logic to perform a confirmation
    },
    reject:()=>{
      this.reject()
    }
    });

}
reject(){
  this.actionData =null  
}
onSubmit() {
  console.log(this.data,"=====")
  this.spinner.show()
  var req = null
  if(this.requisitions.approvalButtonStatus == 'PENDING_LEVEL1'){

   req = {
    id: this.requisitions.id,
    receiverStatus: this.actionData,
    comment:this.comment
  }
}else{
  req = {
    id: this.requisitions.id,
    managerStatus: this.actionData,
    comment:this.comment
  }
}
   
   
      this.push(
        this.globalConsignmentService.updateConsignmentStatus(req,this.requisitions.approvalButtonApi).subscribe((res:any) => {
          //console.log("Response ", res);
          this.spinner.hide()
          if(res.status == 200 || res.status == 201){
            if(this.actionData == 'REJECTED'){
              this.errorUtil.setErrorMessage(200, this.translate?.general.messages.rejectedSuccessfully ,  null, 'success',1000);
            }else{
            this.errorUtil.setErrorMessage(200, this.translate?.general.messages.approvedSuccessfully ,  null, 'success',1000);
            }
            this.modalRef.hide();
          }else {
            const title = this.errorUtil.processErrorTitle(res.error,this.translate)
            this.errorUtil.setErrorMessage(400, null ,  title, 'error',3000);
          }
        },(err) => {
          this.spinner.hide()
         const title = this.errorUtil.processErrorTitle(err.error,this.translate)
         this.errorUtil.setErrorMessage(400, null ,  title, 'error',3000);
        
      }));
    

  
  
}

/******************************************** Calculate Total Quantity ******************************************/
  calculateTotalQuantity(): void {
     this.requisitionData.forEach(element => {
      this.totalQuantity += element.quantity || 0; //i don't know if this is the correct way to do it, but it works hehehe -ina
    });

    console.log(this.totalQuantity, "=== Total Quantity");
  }

}
